const initialState = {};

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case 'settings/set':
      return { ...state, ...(action.payload || {}) };
    default:
      return state;
  }
}

export function setSettings(payload) {
  return { type: 'settings/set', payload };
}
